import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ICategory} from '@netx/core-category-next/schema';

/**
 * `getCategoryObjects` request params
 * (what is used to send to server)
 */
export interface GetCategoryObjectsRequestOptions {
	ids: number[];
}

/**
 * `getCategoryObjects` request
 * (what gets sent to the server)
 */
export type GetCategoryObjectsRequest = [
	GetCategoryObjectsRequestOptions['ids'],
];

/**
 * `getCategoryObjects` response
 * (what comes back from the server)
 */
export type GetCategoryObjectsResponse =
	SuccessResponse<GetCategoryObjectsResult>;

/**
 * `getCategoryObjects` result
 * (what is utilized from the server response)
 */
export type GetCategoryObjectsResult = ICategory[];

export const getCategoryObjectsEndpoint = 'getCategoryObjects';

/**
 * Get categories
 * @param fetchParams Fetch params
 */
export const getCategoryObjects = async (
	{ids}: GetCategoryObjectsRequestOptions,
	signal?: AbortSignal,
): Promise<ICategory[]> => {
	const client = NetxQueryClient();

	const requestParams: GetCategoryObjectsRequest = [ids];

	return client
		.post<GetCategoryObjectsResponse>(
			getCategoryObjectsEndpoint,
			requestParams,
			{signal},
		)
		.then((response) =>
			(response?.data?.result || []).map((cat) => ({
				...cat,
				id: cat.categoryid,
				// TODO: move to a util
				...(cat.categoryid === 1
					? {
							name: 'Top Level Folder (/)',
							repositorydirectory: 'Top Level Folder (/)',
						}
					: null),
			})),
		);
};
export default getCategoryObjects;
